<ag-mail-send
  #mailSend
  (closed)="close()"
  (showPopup)="openPopup($event)"
  (sent)="sent.emit()"
></ag-mail-send>
